export default __webpack_public_path__ + "static/media/download-white.f8b7f0aa.svg";